import { RecordHistoryPage } from '@/components/audit-log/RecordHistoryPage'
import { usePathHelper } from '@/hooks/usePathHelper'
import { adminTitleHead } from '@/lib/admin-route-title'
import { auditLogQueries } from '@/lib/services/audit-log/audit-log.query'
import { snapdragonQueries } from '@/lib/services/snapdragon/snapdragon.query'
import { createFileRoute, notFound } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/$orgId/settings/integrations/snapdragon/history'
)({
  component: SnapdragonSettingsHistoryPage,
  head: () => adminTitleHead('History', 'Snapdragon', 'Integrations', 'Settings'),
  loader: async ({ context, params }) => {
    if (
      !context.ability.can('list', 'snapdragon-settings') ||
      !context.ability.can('view', 'audit-logs')
    ) {
      throw notFound()
    }

    await Promise.all([
      context.queryClient.ensureQueryData(
        snapdragonQueries.salesOrderAutoPrintSettings({ organizationId: params.orgId })
      ),
      context.queryClient.ensureInfiniteQueryData(
        auditLogQueries.record({
          organizationId: params.orgId,
          subject: 'snapdragon-settings',
          recordId: params.orgId,
        })
      ),
    ])
  },
})

function SnapdragonSettingsHistoryPage() {
  const { orgId } = Route.useParams()
  const path = usePathHelper()

  return (
    <RecordHistoryPage
      backLabel="Snapdragon settings"
      backLink={path.snapdragon.index().link}
      description="Review changes to automatic sales-order printing and printer defaults."
      organizationId={orgId}
      recordId={orgId}
      recordLabel="Snapdragon settings"
      subject="snapdragon-settings"
    />
  )
}
